import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "lodash"

import "./index.css"

import Addresses from "./Components/Addresses";
import DispatchAddress from "./Components/DispatchAddress";
import TranspotationDetails from "./Components/TranspotationDetails";

import { Button } from "../../helpers";
import Loading from "../../common/Loading";

import { fetchLogisticPartners, fetchPinCodes } from "../../services/redux/reducers/commonThunk";
import { generateEwayBill } from "../../services/api/buyerInvoice";
import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { Checkbox } from "primereact/checkbox";
import { getPMCompanyConfig } from "../../setup/pmCompanyConfig";


const GenerateEwayBill = (props) =>{
    const { buyerInvoice, buyerInvoiceItems, materialDetails, pmCompanyBillAddrDetails, buyerBillAddrDetails, buyerShipAddrDetails, statesList, invoiceObj, productDetails, docType } = props
    const [isTransporterAvailable, setIsTransporterAvailable] = useState({})
    const [transportationDetails, setTransportationDetails] = useState({})
    const [useBillAddrsAsDispatch, setUseBillAddrsAsDispatch] = useState(true)
    const [dispatchDetails, setDispatchDetails] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [pmCompanyShipAddrDetails, setPMCompanyShipAddrDetails] = useState({})

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const logisticPartners = useSelector(state => state.common.logisticPartners)
    const uniqueLogisticPartners = _.uniqBy(logisticPartners, 'partnerName')
    const pinCodesData = useSelector(state => state.common.pinCodes)
    const userDetails = useSelector(state => state.userDetails)
    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)

    const PMCompanyDetails = userDetails.PMCompanyDetails

    useEffect(() => {
        dispatch(fetchLogisticPartners())
        dispatch(fetchPinCodes())
    }, [])

    // useEffect(() => {
    //     setDispatchDetails({...pmCompanyBillAddrDetails, stateId: parseInt(pmCompanyBillAddrDetails.stateId)})
    // }, [pmCompanyBillAddrDetails])

    useEffect(() => {
        if(PMCompanyDetails){
            let relatedPMBranch = PMCompanyDetails.companyPmBranches.find(eachBranch => eachBranch.branchId === buyerInvoice.pmBranchId)
            let relatedWarehouse = PMCompanyDetails.companyWarehouses.find(eachWarehouse => eachWarehouse.warehouseId === relatedPMBranch?.warehouseId)
            let relatedShipAddr = PMCompanyDetails.companyBranchShipAddrs.find(eachShipAddr => eachShipAddr.shipAddrId === relatedWarehouse?.shipAddrId)

            let defaultShipAddr = {
                companyName: pmCompanyBillAddrDetails.companyName,
                gstinCode: pmCompanyBillAddrDetails.gstinCode
            }
            if(relatedShipAddr){
                defaultShipAddr = {
                    ...defaultShipAddr,
                    ...relatedShipAddr,
                    stateId: parseInt(relatedShipAddr.stateId)
                }
            }

            setPMCompanyShipAddrDetails({...defaultShipAddr})
            setDispatchDetails({...defaultShipAddr})
        }
    }, [buyerInvoice])

    const handleGenerateClick = async () => {
        let validateDispatchAddr = dispatchAddrValidation()
        if(!validateDispatchAddr){
            return false
        }
        if (isTransporterAvailable){
            if (!transportationDetails.transporterName){
                return dispatch(raiseToast({severity:'error', detail: 'Please Enter Transporter Name', life: 3000}))
            }else if (!transportationDetails.transporterGSTIN){
                return dispatch(raiseToast({severity:'error', detail: 'Please Enter Transporter GSTIN', life: 3000}))
            }
        }

        if (!isTransporterAvailable){
            if(!transportationDetails.byRoad || transportationDetails.byRail || transportationDetails.byAir || transportationDetails.byShip){
                return dispatch(raiseToast({severity:'error', detail: 'Please select transport mode', life: 3000}))
            }
            if (!transportationDetails.vehicleNo){
                return dispatch(raiseToast({severity:'error', detail: 'Please Enter Vehicle No.', life: 3000}))
            }
        }

        if (window.confirm("Do you want to continue..?")){
            let transMode = ""
            if (transportationDetails?.byRoad){
                transMode = "1"
            }else if (transportationDetails?.byRail){
                transMode = "2"
            }else if (transportationDetails?.byAir){
                transMode = "3"
            }else if (transportationDetails?.byShip){
                transMode = "4"
            }
            setIsLoading(true)
            let updatedTransportationDetails = {
                transporterName: transportationDetails?.transporterName ? transportationDetails?.transporterName : "",
                transporterGSTIN: transportationDetails?.transporterGSTIN ? transportationDetails?.transporterGSTIN : "",
                vehicleNo: transportationDetails?.vehicleNo ? transportationDetails?.vehicleNo : "",
                transDistance: transportationDetails?.transportationDistance ? transportationDetails?.transportationDistance : 0,
                transMode: transMode
            }
            let eWayBillData = {
                // buyerInvoice: buyerInvoice,
                // buyerInvoiceItems: buyerInvoiceItems,
                invoiceObj: invoiceObj,
                productDetails: productDetails,
                transportationDetails: updatedTransportationDetails,
                dispatchDetails: dispatchDetails
            }
            const eWayBillResponse = await generateEwayBill(eWayBillData)
            console.log("eWayBillResponse", eWayBillResponse)
            if (eWayBillResponse?.failure){
                dispatch(raiseToast({severity:'error', summary: 'Generate E-Way Bill', detail: eWayBillResponse?.data?.error, life: 3000}))
            }else{
                dispatch(raiseToast({severity:'success', detail: 'E-Way Bill has Generated', life: 3000}))
                navigate(`/Eway_bill_document/${eWayBillResponse?.data?.ewayBillId}`)
            }
            setIsLoading(false)
        }
    }

    const dispatchAddrValidation = () => {
        if(!dispatchDetails.shipAddr?.trim()){
            dispatch(raiseToast({severity:'error', detail: 'Please enter dispatch address', life: 3000}))
            return false
        }

        if(!dispatchDetails.pinCode?.trim()){
            dispatch(raiseToast({severity:'error', detail: 'Please enter dispatch pincode', life: 3000}))
            return false
        }else{
            if(dispatchDetails.pinCode?.length != 6){
                dispatch(raiseToast({ severity: 'warn', detail: "Dispatch must be exactly 6 characters", life: 3000}))
                return false
            }
        }

        if(!dispatchDetails.city?.trim()){
            dispatch(raiseToast({severity:'error', detail: 'Please enter dispatch city', life: 3000}))
            return false
        }

        if(!dispatchDetails.stateId){
            dispatch(raiseToast({severity:'error', detail: 'Please select dispatch state', life: 3000}))
            return false
        }

        if(!dispatchDetails.companyName?.trim()){
            dispatch(raiseToast({severity:'error', detail: 'Please enter dispatch company name', life: 3000}))
            return false
        }

        if(!dispatchDetails.gstinCode?.trim()){
            dispatch(raiseToast({severity:'error', detail: 'Please enter dispatch GSTIN', life: 3000}))
            return false
        }

        return true
    }

    const handleDispatchCheckboxOnchange = (event) => {
        if(event.target.checked){
            setUseBillAddrsAsDispatch(true)
            // setDispatchDetails({...pmCompanyBillAddrDetails, stateId: parseInt(pmCompanyBillAddrDetails.stateId)})
            setDispatchDetails({...pmCompanyShipAddrDetails})
        } else {
            setUseBillAddrsAsDispatch(false)
        }
    }

    const handleDispatchAddressChange = (event) => {
        dispatchDetails[event.target.name] = event.target.value

        if (event.target.name === "pinCode" && (event.target.value).length === pmCompanyConfig.pinCodeLength) {
            const relatedPinCode = pinCodesData.find(eachPincode => {
                if (eachPincode.pinCode === parseInt(event.target.value)) {
                    return eachPincode
                }
            })

            if (relatedPinCode && relatedPinCode.stateId){
                const relatedState = statesList.find(eachState => {
                    if (eachState.stateId === relatedPinCode.stateId) {
                        return true
                    }
                    return false
                })
                if(relatedState){
                    dispatchDetails["stateId"] = relatedState.stateId
                }
            } else {
                return dispatch(raiseToast({ severity: 'warn', detail: "Please enter valid pincode" }))
            }
        } else {
            if (event.target.name === "pinCode") {
                dispatchDetails["stateId"] = null
            }
        }
        setDispatchDetails({ ...dispatchDetails })
    }

    return(
        <div className="generate-eway-bill mb-3">
            <div className="flex flex-row justify-content-center text-sm"><h3 className="mb-1 mt-2"><span>{docType === "invoice" ? `Invoice` : `Credit Note`} No: </span>{invoiceObj?.docNo}<span></span></h3></div>
            <h4 className="mt-2 mb-1">Product Details:</h4>
            <div className="p-card pb-1">
                <table className="custom-table" style={{ width: "100%" }}>
                    <thead >
                        <tr className="custom-table-tr">
                            <th className="custom-th" >SR</th>
                            <th className="custom-th" >PRODUCT</th>
                            <th className="custom-th" >HSN/SAC</th>
                            <th className="custom-th" >SPECIFICATION</th>
                            <th className="custom-th" >QUANTITY</th>
                            <th className="custom-th" >UNITPRICE</th>
                            <th className="custom-th" >PRICE BEFORE TAX</th>
                            <th className="custom-th" >CGST</th>
                            <th className="custom-th" >CGST RATE</th>
                            <th className="custom-th" >SGST </th>
                            <th className="custom-th" >SGST RATE</th>
                            <th className="custom-th" >IGST</th>
                            <th className="custom-th" >IGST RATE</th>
                            <th className="custom-th" >LINE TOTAL</th>
                        </tr>
                    </thead>
                    <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                        {
                           productDetails?.map((eachProduct, index )=> {
                                const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === eachProduct?.materialId)
                                // const isIGST = pmCompanyBillAddrDetails?.stateId === buyerBillAddrDetails?.stateId ? false : true
                                // const IGSTTaxRate = isIGST ? eachProduct?.GSTRate : 0
                                // const IGSTTax = IGSTTaxRate * eachProduct?.itemAmountBeforeTax * 0.01
                                // const CGSTTaxRate = !isIGST ? (eachProduct?.GSTRate/2): 0
                                // const CGSTTax = CGSTTaxRate * eachProduct?.itemAmountBeforeTax * 0.01
                                // const SGSTTaxRate = !isIGST ? (eachProduct?.GSTRate / 2): 0
                                // const SGSTTax = SGSTTaxRate * eachProduct?.itemAmountBeforeTax * 0.01
                                return (
                                    <tr className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                        <td className="custom-td">{index + 1}</td>
                                        <td className="custom-td">{relatedMaterial?.productName}</td>
                                        <td className="custom-td">{eachProduct?.HSNCode}</td>
                                        <td className="custom-td">{relatedMaterial?.productSpecification}</td>
                                        <td className="custom-td">{eachProduct?.qty} {relatedMaterial?.UOM}</td>
                                        <td className="custom-td">{eachProduct?.unitPrice}</td>
                                        <td className="custom-td">{eachProduct?.itemAmountBeforeTax}</td>
                                        <td className="custom-td">{eachProduct?.CGSTTaxRate}%</td>
                                        <td className="custom-td">{eachProduct?.CGSTTax}</td>
                                        <td className="custom-td">{eachProduct?.SGSTTaxRate}%</td>
                                        <td className="custom-td">{eachProduct?.SGSTTax}</td>
                                        <td className="custom-td">{eachProduct?.IGSTTaxRate}%</td>
                                        <td className="custom-td">{eachProduct?.IGSTTax}</td>
                                        <td className="custom-td">{eachProduct?.itemAmountWithTax}</td>
                                    </tr>
                                )
                            })
                        }
                        <tr className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                            <td className="custom-td"></td>
                            <td className="custom-td"></td>
                            <td className="custom-td"></td>
                            <td className="custom-td"></td>
                            <td className="custom-td"></td>
                            <td className="custom-td">TOTAL</td>
                            <td className="custom-td"></td>
                            <td className="custom-td"></td>
                            <td className="custom-td"></td>
                            <td className="custom-td"></td>
                            <td className="custom-td"></td>
                            <td className="custom-td"></td>
                            <td className="custom-td"></td>
                            <td className="custom-td">{invoiceObj?.totalInvAmount}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
            <h4 className="mt-2 mb-2">Addresses:</h4>
            <div className="">
                <Addresses buyerInvoice={buyerInvoice} pmCompanyBillAddrDetails={pmCompanyBillAddrDetails} buyerBillAddrDetails={buyerBillAddrDetails} buyerShipAddrDetails={buyerShipAddrDetails}/>
            </div>

            <h4 className="mt-2 mb-1">Dispatch Address:</h4>
            <Checkbox inputId="dispatch_address_checkbox" checked={useBillAddrsAsDispatch} onChange={handleDispatchCheckboxOnchange}/>
            <label htmlFor="dispatch_address_checkbox" className="ml-2">Unselect to change dispatch address</label>
            <div className="mt-2 mb-1">
                <DispatchAddress 
                    buyerInvoice={buyerInvoice} 
                    dispatchDetails={dispatchDetails} 
                    useBillAddrsAsDispatch={useBillAddrsAsDispatch} 
                    statesList={statesList}
                    handleDispatchAddressChange={handleDispatchAddressChange}
                />
            </div>
            
            <h4 className="mt-2 mb-1">Transpotation Details:</h4>
            <div>
                <TranspotationDetails 
                    isTransporterAvailable={isTransporterAvailable} 
                    pmCompanyBillAddrDetails={pmCompanyBillAddrDetails} 
                    buyerShipAddrDetails={buyerShipAddrDetails} 
                    setIsTransporterAvailable={setIsTransporterAvailable} 
                    logisticPartners={logisticPartners} 
                    uniqueLogisticPartners={uniqueLogisticPartners} 
                    transportationDetails={transportationDetails} 
                    setTransportationDetails={setTransportationDetails}
                    dispatchDetails={dispatchDetails}
                />
            </div>

            <div className="flex flex-row justify-content-center">
                <Button label="GENERATE" onClick={handleGenerateClick}/>
                <Button className="ml-4" label="CANCEL" />
            </div>

            <Loading visible={isLoading} />
        </div>
    )
}

export default GenerateEwayBill;